// services/modules/Ventas.js
import proyecto from "../../api/Proyecto";
import { getSelectedCajaId } from "../../helpers/cajaSelection";

export const insertarVenta = async (venta) => {
  const res = await proyecto.post("/ventas", { ...venta, id_caja: getSelectedCajaId() });
  return res.data;
};

export const GenerarFactura = async (factura) => {
  const res = await proyecto.post("/facturacion/certificar", factura);
  return res.data;
};

export const getFacturacionStatus = async () => {
  const res = await proyecto.get("/facturacion/status");
  return res.data;
};

export const getTiposDocumento = async () => {
  const res = await proyecto.get("/ventas/tipos-documento");
  return res.data;
};

export const getTiposVenta = async () => {
  const res = await proyecto.get("/ventas/tipos-venta");
  return res.data;

};
// services/modules/Ventas.js
export const getUnidadesPorProducto = async (productoId) => {
  const res = await proyecto.get(`/productos/unidades/${productoId}`); // ✅ esta es la correcta
  return res.data;
};
